// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 *
 * Copyright 2018 Odysseus Data Services, inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 *  limitations under the License.
 *
 * Company: Odysseus Data Services, Inc.
 * Product Owner/Architecture: Gregory Klebanov
 * Authors: Alexandr Saltykov, Pavel Grafkin, Vitaly Koulakov, Anton Gackovka
 * Created: October 3, 2018
 *
 *//*!
 *
 * Copyright 2018 Odysseus Data Services, inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 *  limitations under the License.
 *
 * Company: Odysseus Data Services, Inc.
 * Product Owner/Architecture: Gregory Klebanov
 * Authors: Alexandr Saltykov, Pavel Grafkin, Vitaly Koulakov, Anton Gackovka
 * Created: March 3, 2017
 *
 *//*!
 *
 * Copyright 2018 Odysseus Data Services, inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 *  limitations under the License.
 *
 * Company: Odysseus Data Services, Inc.
 * Product Owner/Architecture: Gregory Klebanov
 * Authors: Alexandr Saltykov, Pavel Grafkin, Vitaly Koulakov, Anton Gackovka
 * Created: March 3, 2017
 *
 */.at-license-agreement-modal{max-width:900px;height:500px;overflow:auto;padding:1rem}.at-license-agreement-modal__title{font-weight:bold;font-size:1.5rem}.at-license-agreement-modal__line,.at-license-agreement-modal li{margin:1rem 0;line-height:1.25}.at-license-agreement-modal__list{list-style:decimal;margin:0 0 0 2rem}.at-license-agreement-modal__sublist{list-style:lower-latin;margin:0 0 0 2rem}.at-license-agreement-modal__strong{font-weight:500}.at-license-agreement-modal__actions{padding:1rem;display:flex;justify-content:flex-end}`, "",{"version":3,"sources":["webpack://./modules/Portal/components/LicenseAgreement/style.scss"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAAA,CAAA;;;;;;;;;;;;;;;;;;;;EAAA,CAAA;;;;;;;;;;;;;;;;;;;;EAAA,CA0BG,4BACE,eAAA,CACA,YAAA,CACA,aAAA,CACA,YAAA,CAEA,mCACE,gBAAA,CACA,gBAAA,CAGF,iEACC,aAAA,CACA,gBAAA,CAGD,kCACC,kBAAA,CACA,iBAAA,CAGD,qCACC,sBAAA,CACA,iBAAA,CAGD,oCACC,eAAA,CAGD,qCACC,YAAA,CACA,YAAA,CACA,wBAAA","sourcesContent":["/*!\n *\n * Copyright 2018 Odysseus Data Services, inc.\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n * http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n *  limitations under the License.\n *\n * Company: Odysseus Data Services, Inc.\n * Product Owner/Architecture: Gregory Klebanov\n * Authors: Alexandr Saltykov, Pavel Grafkin, Vitaly Koulakov, Anton Gackovka\n * Created: October 3, 2018\n *\n */\n\n @use 'styles/vars-and-mixins' as *;\n\n .#{$namespace} {\n\n   &license-agreement-modal {\n     max-width: 900px;\n     height: 500px;\n     overflow: auto;\n     padding: 1rem;\n\n     &__title {\n       font-weight: bold;\n       font-size: 1.5rem;\n     }\n\n     &__line, & li {\n      margin: 1rem 0;\n      line-height: 1.25;\n     }\n\n     &__list {\n      list-style: decimal;\n      margin: 0 0 0 2rem;\n     }\n\n     &__sublist {\n      list-style: lower-latin;\n      margin: 0 0 0 2rem;\n     }\n\n     &__strong {\n      font-weight: 500;\n     }\n\n     &__actions {\n      padding: 1rem;\n      display: flex;\n      justify-content: flex-end;\n     }\n   }\n }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
